import { c as _c } from "react/compiler-runtime";
import { type ComponentType, type ReactNode, useMemo } from 'react';
import { useChartAxisIdsAndDomains } from '../hooks';
import { ChartElementContext } from '../hooks/chartElementContext';
import type { ChartElementContextValue, ChartZoomedIn } from '../internalTypes';
import type { ChartCardGridSize, ChartType, LayoutType } from '../types';
interface ChartElementContextProviderProps {
  children: ReactNode;
  chartType: ChartType;
  layout: LayoutType;
  size: ChartCardGridSize;
  width: number;
  height: number;
  zoomedIn: ChartZoomedIn;
  firstAxisId: string;
  secondAxisId: string;
  otherSecondAxisId: string | undefined;
}
const ChartElementContextProvider: ComponentType<ChartElementContextProviderProps> = t0 => {
  const $ = _c(21);
  const {
    children,
    layout,
    chartType,
    size,
    width,
    height,
    zoomedIn,
    firstAxisId,
    secondAxisId,
    otherSecondAxisId
  } = t0;
  let t1;
  if ($[0] !== firstAxisId || $[1] !== height || $[2] !== layout || $[3] !== otherSecondAxisId || $[4] !== secondAxisId || $[5] !== size || $[6] !== width || $[7] !== zoomedIn) {
    t1 = {
      layout,
      size,
      width,
      height,
      zoomedIn,
      firstAxisId,
      secondAxisId,
      otherSecondAxisId
    };
    $[0] = firstAxisId;
    $[1] = height;
    $[2] = layout;
    $[3] = otherSecondAxisId;
    $[4] = secondAxisId;
    $[5] = size;
    $[6] = width;
    $[7] = zoomedIn;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const chartAxisIdsAndDomains = useChartAxisIdsAndDomains(t1);
  let t2;
  if ($[9] !== chartAxisIdsAndDomains || $[10] !== chartType || $[11] !== firstAxisId || $[12] !== layout || $[13] !== otherSecondAxisId || $[14] !== secondAxisId || $[15] !== size || $[16] !== zoomedIn) {
    t2 = {
      layout,
      chartType,
      size,
      zoomedIn,
      firstAxisId,
      secondAxisId,
      otherSecondAxisId,
      chartAxisIdsAndDomains
    };
    $[9] = chartAxisIdsAndDomains;
    $[10] = chartType;
    $[11] = firstAxisId;
    $[12] = layout;
    $[13] = otherSecondAxisId;
    $[14] = secondAxisId;
    $[15] = size;
    $[16] = zoomedIn;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  const value = t2;
  let t3;
  if ($[18] !== children || $[19] !== value) {
    t3 = <ChartElementContext.Provider value={value}>{children}</ChartElementContext.Provider>;
    $[18] = children;
    $[19] = value;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  return t3;
};
export default ChartElementContextProvider;